<mat-form-field class="mat-field-width">
    <input matInput 
            [type]="controlType"
            placeholder="{{localConfig.label}}" 
            [errorStateMatcher]="errorState"
            [value]="localValue"
            [disabled]="disabled"
            (keyup)="keyUp($event)"
            (blur)="blur()"
            (focus)="focus()"/>
    <span matSuffix *ngIf="localConfig.tooltip">
        <app-field-tooltip-suffix [tooltip]="localConfig.tooltip" ></app-field-tooltip-suffix>
    </span>
    <mat-error>
        <span>{{localConfig.validation}}</span>
    </mat-error>
</mat-form-field>  